import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { useRTLTheme } from '@/shared/hooks/useRTLTheme';

// ==============================|| DEFAULT THEME - MAIN  ||============================== //

export default function CustomTheme({ children }: { children: JSX.Element }) {
  const themes = useRTLTheme();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
